import { render, staticRenderFns } from "./joiner_product_add.vue?vue&type=template&id=928a82de&scoped=true&"
import script from "./joiner_product_add.vue?vue&type=script&lang=js&"
export * from "./joiner_product_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928a82de",
  null
  
)

export default component.exports